import { render, staticRenderFns } from "./UserTreeSelect.vue?vue&type=template&id=3dfde1fc&scoped=true&"
import script from "./UserTreeSelect.vue?vue&type=script&lang=js&"
export * from "./UserTreeSelect.vue?vue&type=script&lang=js&"
import style0 from "./UserTreeSelect.vue?vue&type=style&index=0&id=3dfde1fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfde1fc",
  null
  
)

export default component.exports